import React from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
// import { render } from '@testing-library/react';
// style
import tableIcons from '../../../components/table/MaterialTableIcon';

// Utils
import exportCsv from '../../../utils/export/Csv';

import {
  BasinIcon,
} from '../../../utils/Icon';

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box py={1}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

// function a11yProps(index) {
//   return {
//     id: `noti_modal_tab-${index}`,
//     'aria-controls': `scrollable-auto-tabpanel-${index}`,
//   };
// }

export default function SituationList(props) {
  const { t } = useTranslation();
  // const [value, setValue] = useState(0);
  const { datas, userIsLogin } = props;
  const isExport = (userIsLogin) ? { csv: true } : userIsLogin;

  // const [arrayImage, setarrayImage] = useState({
  //   image_path: '',
  //   image_title: '',
  //   image_credits: '',
  // });
  // const [isOpen, setisOpen] = useState(false);
  // const [photoIndex, setphotoIndex] = useState(0);
  // หน้าประกาศ แจ้งเตือนสถานการณ์
  const customLink = (rowData) => (
    <Link href={rowData.guid.rendered} target="_blank">
      <Box display="flex" alignItems="center">
        <BasinIcon style={{ fontSize: 30, marginRight: 10 }} />
        <Box style={{ color: '#00000099' }}>
          {` ${moment(rowData.date).add(543, 'years').locale('th').format('ll')} `}
          {rowData.title.rendered}
        </Box>
      </Box>
    </Link>
  );

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  return (
    <>
      {/* <Tabs
        value={value}
        onChange={handleChange}
        aria-labelledby="simple tabs example"
        textColor="primary"
        indicatorColor="primary"
        variant="standard"
        TabIndicatorProps={{
          style: { height: '3px' },
        }}
        style={{ borderBottom: '1px solid #ccc' }}
      >
        <Tab label={'ติดตามสถานการณ์ลุ่มน้ำ'} {...a11yProps(0)} textColor="colorPrimary" style={{ padding: '10px' }} />
        <Tab label={'ประกาศ แจ้งเตือนสถานการณ์'} {...a11yProps(1)} style={{ whiteSpace: 'noWrap' }} />
      </Tabs>
      <TabPanel value={value} index={0}> */}
        {/* <MaterialTable
          icons={tableIcons}
          columns={[
            {
              title: t('สถานี'),
              title_export: t('สถานี'),
              field: 'title',
              type: 'string',
              headerStyle: {
                backgroundColor: '#FFFFFF',
                display: 'none',
              },
              render: (row) => customLink(row),
            },
          ]}
          data={datas2}
          localization={{
            pagination: {
              labelRowsSelect: t('แถว'),
            },
            body: { emptyDataSourceMessage: <h3>{t('ไม่มีข้อมูลตามเงื่อนไข')}</h3> },
          }}
          options={{
            tableLayout: 'fixed',
            pageSize: 5,
            sorting: true,
            search: false,
            rowStyle: {
              wordWrap: 'break-word',
            },
            toolbar: isExport,
            showTitle: false,
            exportButton: isExport,
            exportCsv,
          }}
          style={{ boxShadow: 'none' }}
        /> */}
      {/* </TabPanel>
      <TabPanel value={value} index={1}>
        <MaterialTable
          icons={tableIcons}
          columns={[
            {
              title: t('สถานี'),
              title_export: t('สถานี'),
              field: 'title',
              type: 'string',
              headerStyle: {
                backgroundColor: '#FFFFFF',
                display: 'none',
              },
              render: (row) => customLink(row),
            },
          ]}
          data={datas}
          localization={{
            pagination: {
              labelRowsSelect: t('แถว'),
            },
            body: { emptyDataSourceMessage: <h3>{t('ไม่มีข้อมูลตามเงื่อนไข')}</h3> },
          }}
          options={{
            tableLayout: 'fixed',
            pageSize: 5,
            sorting: true,
            search: false,
            rowStyle: {
              wordWrap: 'break-word',
            },
            toolbar: isExport,
            showTitle: false,
            exportButton: isExport,
            exportCsv,
          }}
          style={{ boxShadow: 'none' }}
        />
      </TabPanel> */}
      <MaterialTable
        icons={tableIcons}
        columns={[
          {
            title: t('สถานี'),
            title_export: t('สถานี'),
            field: 'title',
            type: 'string',
            headerStyle: {
              backgroundColor: '#FFFFFF',
              display: 'none',
            },
            render: (row) => customLink(row),
          },
        ]}
        data={datas}
        localization={{
          pagination: {
            labelRowsSelect: t('แถว'),
          },
          body: { emptyDataSourceMessage: <h3>{t('ไม่มีข้อมูลตามเงื่อนไข')}</h3> },
        }}
        options={{
          tableLayout: 'fixed',
          pageSize: 5,
          sorting: true,
          search: false,
          rowStyle: {
            wordWrap: 'break-word',
          },
          toolbar: isExport,
          showTitle: false,
          exportButton: isExport,
          exportCsv,
        }}
        style={{ boxShadow: 'none' }}
      />
    </>
  );
}

SituationList.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
  userIsLogin: PropTypes.bool.isRequired,
};
